export default "__VITE_ASSET__CQgHNraO__"